import { set } from 'lodash';

import formActionDispatcher from 'APP_ROOT/utils/formDispatchEmitter';
import syncFormData from 'APP_ROOT/actions/sync-form-data';
import syncFormReviewData from 'APP_ROOT/actions/sync-form-review-data';
import syncFormValueChanged from 'APP_ROOT/actions/sync-form-value-changed-boolean';

const saveFieldDataValue = async (props, newValue, autoSave = true) => {
  const {
    options = {},
    parentIndex,
    parentKey,
    dataKey,
    isPreviewModeEnabled,
  } = props;
  const settings = options.settings || props.settings || {};
  const { formName } = settings;
  const syncData = formName === 'form' ? syncFormData : syncFormReviewData;

  if (newValue !== props.value) {
    const value = { [dataKey]: newValue };
    let dataValue;
    if (parentKey) {
      dataValue = { [parentKey]: [] };
      set(dataValue, [parentKey, parentIndex], value);
    } else {
      dataValue = value;
    }

    // using setTimeout to avoid problems with race conditions
    setTimeout(() => {
      const autoSaveEnabled = autoSave && !isPreviewModeEnabled;
      autoSaveEnabled &&
        formActionDispatcher(formName, syncFormValueChanged(true));
      formActionDispatcher(formName, syncData(dataValue));
    }, 100);
  }
};

export default saveFieldDataValue;
